import Vue from "vue";
const state = Vue.observable({ visible: false, content: "" });
let tooltip = null;
export default {
  bind(el, binding) {
    if (!tooltip) {
      const Instance = Vue.extend({
        render(h) {
          return h(
            "el-tooltip",
            {
              ref: "tooltip",
              props: {
                effect: "light",
                placement: "top",
                value: state.visible,
              },
            },
            [
              typeof state.content === "object"
                ? h(
                    "div",
                    {
                      slot: "content",
                    },
                    state.content
                  )
                : h("div", {
                    slot: "content",
                    domProps: {
                      innerHTML: state.content,
                    },
                  }),
            ]
          );
        },
      });
      tooltip = new Instance().$mount();
      document.body.appendChild(tooltip.$el);
    }
    el.__tip = binding.value;
    el.addEventListener("mouseenter", function (e) {
      if (
        el.scrollWidth > el.offsetWidth ||
        binding.modifiers.show ||
        el.scrollHeight > el.offsetHeight
      ) {
        let placement = "top";
        if (binding.modifiers.left) {
          placement = "left";
        } else if (binding.modifiers.right) {
          placement = "right";
        } else if (binding.modifiers.bottom) {
          placement = "bottom";
        } else if (binding.modifiers.top) {
          placement = "top";
        }
        const tip = tooltip.$refs.tooltip;
        tip.$refs.popper && (tip.$refs.popper.style.display = "none");
        tip.doDestroy();
        tip.setExpectedState(true);
        tip.referenceElm = e.srcElement;
        state.content = el.__tip;
        tip.currentPlacement = placement;
        state.visible = true;
      }
    });
    el.addEventListener("mouseleave", function (e) {
      tooltip.$refs.tooltip.referenceElm = e.srcElement;
      state.visible = false;
    });
  },
  update(el, binding) {
    el.__tip = binding.value;
  },
  unbind() {
    state.visible = false;
  },
};
